import { chakra, HTMLChakraProps, useStyleConfig } from "@chakra-ui/react";

export interface FormFieldsetProps extends HTMLChakraProps<"fieldset"> {
  variant?: "solid" | "dashed" | "overline";
}

export const FormFieldset: React.FC<
  React.PropsWithChildren<FormFieldsetProps>
> = ({ children, variant, ...props }) => {
  const style = useStyleConfig("Fieldset", { variant });
  return (
    <chakra.fieldset __css={style} {...props}>
      {children}
    </chakra.fieldset>
  );
};
